import api from './api';
import { ISpringPage } from 'interfaces/shared.interface';
import {
  InventoryDailySummaryDto,
  InventoryReportParams,
  InventoryReportRowDto,
  InventoryReportStatsDto,
  InventorySeriesResult,
} from 'interfaces/report.interface';

const _resourceUrl = '/report/inventory';

export const getInventoryReportRows = (
  params: InventoryReportParams & { page: number; size: number; sort: string },
): Promise<ISpringPage<InventoryReportRowDto>> => {
  return api.get(_resourceUrl, { params });
};

export const getInventoryDailySummary = (
  params: InventoryReportParams,
): Promise<InventoryDailySummaryDto[]> => {
  return api.get(`${_resourceUrl}/daily-summary`, { params });
};

export const getInventoryReportStats = (
  params: InventoryReportParams,
): Promise<InventoryReportStatsDto> => {
  return api.get(`${_resourceUrl}/stats`, { params });
};

export const getInventorySeries = (
  params: InventoryReportParams,
): Promise<InventorySeriesResult> => {
  return api.get(`${_resourceUrl}/series`, { params });
};
